import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import "bootstrap-icons/font/bootstrap-icons.css";
import "../static/css/base.css";
import { Footer, Title, Input, Button } from "../utils/utils";
import { Profile } from "../utils/Profile";
import { useNavigate } from "react-router-dom";

var ReactCSSTransitionGroup = require('react-transition-group'); // ES5 with npm
var logoImg = require("../static/images/logo.png");


const gainList = <><p className="question"><b>What can I gain?</b></p>
<ol className="list-group">
<li className="list-group-item list-group-item-primary">Problem solving skills</li>
<li className="list-group-item list-group-item-primary">Learn more about computers</li>
<li className="list-group-item list-group-item-primary">Find out your interests</li>
</ol></>;

const learnList = <><p className="question"><b>What will I learn?</b></p>
You learn best when you are interested in the material.
You can choose from the following topics or inquire for other topics!
<ul className="list-group">
<li className="list-group-item list-group-item-success">Computer Programming</li>
<ul className="list-group">
<li className="list-group-item list-group-item-primary">Problem solving with coding on Python programming language</li>
<li className="list-group-item list-group-item-primary">Desktop applications using Java programming language</li>
<li className="list-group-item list-group-item-primary">Basic Website development using HTML5/CSS</li>
</ul>
<li className="list-group-item list-group-item-success">Math</li>
<ul className="list-group">
<li className="list-group-item list-group-item-primary">Calculus</li>
<li className="list-group-item list-group-item-primary">Advanced functions</li>
<li className="list-group-item list-group-item-primary">Physics</li>
<li className="list-group-item list-group-item-primary">Statistics</li>
</ul>
</ul></>;

const howList=  <><p className="question"><b>How will I learn?</b></p>
<ul className="list-group">
<li className="list-group-item list-group-item-primary">A lesson worksheet will be provided to give a brief introduction to topic</li>
<li className="list-group-item list-group-item-primary">Then, practice problems will be given for you to work on and ask questions</li>
<li className="list-group-item list-group-item-primary">Practical learning</li>
<ul className="list-group">
<li className="list-group-item list-group-item-primary">You will practice programming concepts by coding</li>
<li className="list-group-item list-group-item-primary">Practice Math problems by solving them</li>
<li className="list-group-item list-group-item-primary">Working on a problems that you are interested in</li>
</ul>
<li className="list-group-item list-group-item-primary">Ask questions and get help solving</li>
<li className="list-group-item list-group-item-primary">Optional problems will be assigned to solve on your own</li>
</ul></>;

const needList = <><p className="question"><b>What do I need?</b></p>
<ol className="list-group">
<li className="list-group-item list-group-item-primary">A computer</li>
<li className="list-group-item list-group-item-primary">Positive attitude towards learning</li>
</ol></>;


const gifs = <table className="table"><tbody>
<tr>
<td style={{verticalAlign:"top"}}>
<img alt="for loop" src={require("../static/images/forloop.gif")}
style={{width:"100%"}}/>
</td>
<td style={{verticalAlign:"top"}}>
<img alt="maze game" src={require("../static/images/mazegame.gif")}
style={{width:"100%"}}/></td>
</tr>
</tbody></table>;


function resizeIframe(obj) {
  obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
}

const form =
<div id="wrapper" style={{}}>
<iframe title="form" src="https://docs.google.com/forms/d/e/1FAIpQLSeA3Gz12y8nixZ0L_vqgcOOn0592hHpWxS1FgVn8eMRWutEsA/viewform?embedded=true"
frameBorder="0" marginHeight="1%" marginWidth="0" style={{}}>
Loading…</iframe>
</div>;

const info = <div style={{color:"black", width:"50%"}}>
<br/>
{gainList}
<br/>
{learnList}
<br/>
{howList}
</div>;


export function Home(props) {
  useEffect(() => {
    document.title = "MCS Tutor";
  }, [])

  let navigate = useNavigate();

  //width="640" height="1256"
  //, minWidth:"400px", maxWidth:"50%", width:"50%"
  return (
    <>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <link rel="icon" src={require("../static/images/icon.png")}/>
    <div className="page">
    <br/><div style={{margin:"0 auto", textAlign:"center"}}>
    <img src={logoImg} alt="logo" style={{backgroundColor:"white", width:"15em"}}/>
    </div><br/>
    <b><div style={{backgroundColor:"#F7FF93", textAlign:"center", fontSize:"1em", color:"black"}} className="container">Get Math and Computer Science tutoring in Summer 2023!<br/>$15 per hour. No Subscription required. Parental supervision allowed. 1 hour free trial.</div></b><br/>
    <table className="table" style={{}}>
    <tbody>

    <tr>
    <td/>
    </tr>

    <tr style={{}}>
    <td style={{}}>
    <div style={{display:"flex", textAlign:"center", margin:"0 auto", overflow:"hidden", width:"100%"}}>
    {info}
    {form}
    </div>
    </td>
    </tr>

    <tr>
    <th colSpan="2" style={{textAlign:"center", color:"black", fontSize:"25px", margin:"0 auto"}}>Tutors</th>
    </tr>
    <tr>
    <td colSpan="2">
    <Profile/>
    </td>
    </tr>
    <tr>
    <td colSpan="2">
    {gifs}
    </td>
    </tr>
    </tbody>
    </table>

    </div>
    <Footer/>
    </>
  );
  //width="640" height="1356"
}
